import { Component } from '@angular/core';
import { soundpostReportOutputAgreementGLActivitySummaryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Report Output Agreement GL Activity Summaries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreportoutputagreementglactivitysummary-form',
    templateUrl: './soundpostreportoutputagreementglactivitysummary.form.component.html'
})
export class soundpostReportOutputAgreementGLActivitySummaryFormComponent extends BaseFormComponent {
    public record!: soundpostReportOutputAgreementGLActivitySummaryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

